import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';
import moment from "moment";
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles({
  root: {
    height: "88vh",
    flexGrow: 1,
  },

});

const UsageEventsTreeView = ({ items, sortUsageEventHandler, searchValue, handleItemSelect }: any): JSX.Element => {

  const defaultExpandedNode: string[] = ['rootNode'];
  const [sessionId, setSessionId] = useState("" as string);
  const classes = useStyles();

  useEffect(() => {
    if (searchValue && items && items.length > 0) {
      setSessionId(items[0].sessionId);
      const setDefaultSelectedItem = items.filter(function (obj: any) {
        return (obj.transactionId == searchValue);
      })
      if (setDefaultSelectedItem && setDefaultSelectedItem.length > 0) {
        handleItemSelect(JSON.stringify(setDefaultSelectedItem[0].usageEvent, null, 2));
      }
    }
  }, []);

  const handleSort = () => {
    sortUsageEventHandler();
  }

  const onHandleItemSelect = (data: any) => {
    handleItemSelect(JSON.stringify(data.usageEvent, null, 2));
  };

  return (
    <div className="col-4 p-1">
      <Paper elevation={1} className="h-100 w-100">
        <div className="rounded d-flex justify-content-center bg-light-grey">
          <span>TRANSACTIONS</span>
          <Divider />
        </div>
        <TreeView
          id="usageEventTreeView"
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          defaultSelected={[searchValue]}
          expanded={defaultExpandedNode}
          className={classes.root}
        >
          {items && items.length > 1 && sessionId &&
            <TreeItem nodeId="rootNode" label={`[SessionId: ${sessionId}]`} onClick={handleSort}>
              {items && items.map((item: any, id: number) => {
                return (
                  <TreeItem icon={<ChevronRightIcon />} key={id} onClick={() => onHandleItemSelect(item)} nodeId={item.transactionId} label={`[TranId: ${item.transactionId}]--[Time-stamp: ${moment(item.timestamp).format(moment.HTML5_FMT.DATETIME_LOCAL_MS)}]`} />
                )
              })}
            </TreeItem>
          }
          {items && items.length == 1 &&
            <TreeItem icon={<ChevronRightIcon />} onClick={() => onHandleItemSelect(items[0])} nodeId={items[0].transactionId} label={`[TranId: ${items[0].transactionId}]--[Time-stamp: ${moment(items[0].timestamp).format(moment.HTML5_FMT.DATETIME_LOCAL_MS)}]`} />
          }
        </TreeView>
      </Paper>
    </div>
  );
}

export default UsageEventsTreeView;